<template>
    <v-sheet color="transparent" class="ma-4">
        <v-row class="ma-0">
            <v-text-field
            class="pa-4"
            v-model="searchByText"
            :label="'Buscar por ID/IP'"
            variant="underlined"
            density="compact"
            hide-details
            style="max-width: 200px !important;"
            />

            <v-select
            class="pa-4"
            v-model="sitioFilter"
            :items="listSitios"
            :label="'Sitio'"
            variant="underlined"
            density="compact"
            hide-details
            style="max-width: 200px !important;"
            />

            <v-select
            class="pa-4"
            v-model="estadoFilter"
            :items="listEstados"
            :label="'Estados'"
            variant="underlined"
            density="compact"
            hide-details
            style="max-width: 200px !important;"
            />

            <v-select
            class="pa-4"
            v-model="ordenBY"
            :items="listOrden"
            :label="'Orden'"
            variant="underlined"
            density="compact"
            hide-details
            style="max-width: 200px !important;"
            />
        </v-row>
    </v-sheet>
    <v-sheet  color="transparent" class="ma-4">
        <h2>Resumen por equipos (Tarjetas)</h2>
        <v-row class="ma-0">
            <v-col class="pa-2" cols="2" v-for="(item, i) in filteredItems" :key="i">
                <v-sheet class="energyCardItems">
                    <div> <span class="titleCardEnergy"> {{ item.name }} </span> <span class="subTitleCardEnergy"> • {{ item.sitio }} </span> </div>
                    <div> <span class="subTitleCardEnergy"> IP {{ item.ip }} • {{ item.fw }} • </span> <span class="subTitleCardEnergy__time"> {{ item.time }} </span>  </div>
                    <v-row class="ma-0">
                        <v-col class="pa-0 pr-1" cols="6">
                            <v-sheet class="cardEstaditics">
                                <div> <span class="estadisticsTitle"> SOC </span> </div>
                                <div :style="`color: ${COLORSTATUS[item.estado.toUpperCase()]};`"> <span class="estadisticsValues" >{{ item.soc }}</span> </div>
                            </v-sheet>
                        </v-col>
                        <v-col class="pa-0 pl-1" cols="6">
                            <v-sheet class="cardEstaditics">
                                <div> <span class="estadisticsTitle">Vbat</span> </div>
                                <div> <span class="estadisticsValues">{{ item.vbat }}</span> </div>
                            </v-sheet>
                        </v-col>
                        <v-col class="pa-0 mt-2" cols="12">
                            <v-sheet class="cardEstaditics">
                                <div> <span class="estadisticsTitle"> PV </span> </div>
                                <div> <span class="estadisticsValues">{{ item.pv }}</span> </div>
                            </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 mt-2">
                       <span class="titleCardEnergy mt-1 mr-2"> Estado: </span>
                        <v-chip class="mx-1" variant="outlined" :color="COLORSTATUS[item.estado.toUpperCase()]"> {{ item.estado }} </v-chip>
                        <v-chip class="mx-1" variant="outlined" :color="'red'"> {{ item.estado2 }} </v-chip>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
    </v-sheet>
    <v-sheet class="ma-4" color="transparent" >
        
        <h2>Tabla de Equipos</h2>

        <v-data-table
        v-if="filteredItems.length > 0"
        :headers="HEADER"
        :items="filteredItems"
        density="compact"
        hover
        >
        </v-data-table>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';


const searchByText = ref();
const sitioFilter = ref('Todos los Sitios');
const estadoFilter = ref('Todos los Estados');
const ordenBY = ref('Orden: ID')


const listSitios = ref([ 'Todos los Sitios', 'Campamento', 'Mina Norte', 'Mina Sur', 'Planta A', 'Planta B', 'Subestacion' ]);
const listEstados = ref([ 'Todos los Estados', 'OK', 'WARN', 'ALERT' ]);
const listOrden = ref(['Orden: ID', 'Orden: SOC', 'Orden: PV', 'Orden: Ultimo Dato']);

const COLORSTATUS:any = {
    OK : 'green',
    WARN: 'yellow',
    ALERT: 'red'
}

const HEADER = [    
    { title: 'ID', key: 'name'},
    { title: 'IP', key: 'ip'},
    { title: 'Sitio', key: 'sitio'},
    { title: 'Estado', key: 'estado'},
    { title: 'SOC (%)', key: 'soc'},
    { title: 'Vbat', key: 'vbat'},
    { title: 'Ibat', key: 'ivat'},
    { title: 'PV (W)', key: 'pv'},
    { title: 'AC V', key: 'acv'},
    { title: 'AC W', key: 'acw'},
    { title: 'Alarmas', key: 'estado2'},
    { title: 'Ultimo', key: 'time'},
]

const filteredItems = computed(() => {
  let filtered = [...listITEMS.value]


  if (searchByText.value) {
    const term = searchByText.value.toLowerCase()
    filtered = filtered.filter(item =>
      item.name.toLowerCase().includes(term) ||
      item.ip.toLowerCase().includes(term)
    )
  }


  if (sitioFilter.value !== 'Todos los Sitios') {
    filtered = filtered.filter(item => item.sitio.toLowerCase() === sitioFilter.value.toLowerCase())
  }

  
  if (estadoFilter.value !== 'Todos los Estados') {
    filtered = filtered.filter(item => item.estado.toLowerCase() === estadoFilter.value.toLowerCase())
  }

  
  switch (ordenBY.value) {
    case 'Orden: ID':
      filtered.sort((a, b) => a.name.localeCompare(b.name))
      break
    case 'Orden: SOC':
      filtered.sort((a, b) => parseInt(b.soc) - parseInt(a.soc))
      break
    case 'Orden: PV':
      filtered.sort((a, b) => parseInt(b.pv) - parseInt(a.pv))
      break
    case 'Orden: Ultimo Dato':
      filtered.sort((a, b) => {
        const timeA = parseInt(a.time.replace(/\D/g, ''))
        const timeB = parseInt(b.time.replace(/\D/g, ''))
        return timeA - timeB
      })
      break
  }

  return filtered
})

const listITEMS = ref([
    {
        name: 'cerbo-001',
        sitio : 'mina norte',
        ip: '192.168.0.11',
        fw: 'FW v3.40',
        time: 'hace 9 min',
        soc: '94%',
        vbat: '41.7v',
        pv: '2434 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-002',
        sitio : 'mina sur',
        ip: '192.168.0.12',
        fw: 'FW v3.40',
        time: 'hace 4 min',
        soc: '84%',
        vbat: '30.6v',
        pv: '2377 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-003',
        sitio : 'mina central',
        ip: '192.168.0.13',
        fw: 'FW v3.41',
        time: 'hace 2 min',
        soc: '76%',
        vbat: '39.2v',
        pv: '2510 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-004',
        sitio : 'mina norte',
        ip: '192.168.0.14',
        fw: 'FW v3.40',
        time: 'hace 15 min',
        soc: '68%',
        vbat: '37.8v',
        pv: '2011 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-005',
        sitio : 'mina sur',
        ip: '192.168.0.15',
        fw: 'FW v3.39',
        time: 'hace 7 min',
        soc: '90%',
        vbat: '42.1v',
        pv: '2765 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-006',
        sitio : 'mina este',
        ip: '192.168.0.16',
        fw: 'FW v3.40',
        time: 'hace 1 min',
        soc: '58%',
        vbat: '28.4v',
        pv: '1890 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-007',
        sitio : 'mina oeste',
        ip: '192.168.0.17',
        fw: 'FW v3.41',
        time: 'hace 10 min',
        soc: '82%',
        vbat: '33.5v',
        pv: '2203 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-008',
        sitio : 'mina norte',
        ip: '192.168.0.18',
        fw: 'FW v3.42',
        time: 'hace 3 min',
        soc: '96%',
        vbat: '44.3v',
        pv: '2590 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-009',
        sitio : 'mina sur',
        ip: '192.168.0.19',
        fw: 'FW v3.38',
        time: 'hace 8 min',
        soc: '71%',
        vbat: '35.0v',
        pv: '2101 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-010',
        sitio : 'mina central',
        ip: '192.168.0.20',
        fw: 'FW v3.40',
        time: 'hace 12 min',
        soc: '87%',
        vbat: '38.9v',
        pv: '2294 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-011',
        sitio : 'mina norte',
        ip: '192.168.0.21',
        fw: 'FW v3.41',
        time: 'hace 6 min',
        soc: '65%',
        vbat: '31.4v',
        pv: '1750 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-012',
        sitio : 'mina sur',
        ip: '192.168.0.22',
        fw: 'FW v3.40',
        time: 'hace 9 min',
        soc: '92%',
        vbat: '40.6v',
        pv: '2412 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-013',
        sitio : 'mina este',
        ip: '192.168.0.23',
        fw: 'FW v3.41',
        time: 'hace 14 min',
        soc: '79%',
        vbat: '36.8v',
        pv: '2175 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-014',
        sitio : 'mina oeste',
        ip: '192.168.0.24',
        fw: ' FW v3.39',
        time: 'hace 5 min',
        soc: '88%',
        vbat: '39.9v',
        pv: '2450 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-015',
        sitio : 'mina norte',
        ip: '192.168.0.25',
        fw: 'FW v3.40',
        time: 'hace 11 min',
        soc: '74%',
        vbat: '34.2v',
        pv: '2120 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-016',
        sitio : 'mina central',
        ip: '192.168.0.26',
        fw: 'FW v3.42',
        time: 'hace 13 min',
        soc: '55%',
        vbat: '27.9v',
        pv: '1703 w',
        estado: 'alert',
        estado2: 'AC Fail'
    },
    {
        name: 'cerbo-017',
        sitio : 'mina sur',
        ip: '192.168.0.27',
        fw: 'FW v3.40',
        time: 'hace 2 min',
        soc: '93%',
        vbat: '41.2v',
        pv: '2535 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-018',
        sitio : 'mina este',
        ip: '192.168.0.28',
        fw: 'FW v3.41',
        time: 'hace 16 min',
        soc: '66%',
        vbat: '32.1v',
        pv: '1984 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-019',
        sitio : 'mina oeste',
        ip: '192.168.0.29',
        fw: 'FW v3.40',
        time: 'hace 7 min',
        soc: '81%',
        vbat: '36.0v',
        pv: '2256 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-020',
        sitio : 'mina norte',
        ip: '192.168.0.30',
        fw: 'FW v3.41',
        time: 'hace 10 min',
        soc: '72%',
        vbat: '33.7v',
        pv: '2054 w',
        estado: 'warn',
        estado2: 'AC Facil'
    },
    {
        name: 'cerbo-021',
        sitio : 'mina sur',
        ip: '192.168.0.31',
        fw: 'FW v3.42',
        time: 'hace 3 min',
        soc: '95%',
        vbat: '43.6v',
        pv: '2689 w',
        estado: 'ok',
        estado2: 'AC OK'
    },
    {
        name: 'cerbo-022',
        sitio : 'mina central',
        ip: '192.168.0.32',
        fw: 'FW v3.39',
        time: 'hace 18 min',
        soc: '60%',
        vbat: '29.3v',
        pv: '1820 w',
        estado: 'alert',
        estado2: 'AC Fail'
    }
])


</script>

<style>
.energyCardItems{
    border-radius: 20px;
    padding: 12px;
    height: 270px;
    border: 1px solid white;
    background: linear-gradient(180deg, rgba(255, 255, 255, .03), rgba(0, 0, 0, .15)) !important;
}
.energyCardItems .titleCardEnergy {
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
}

.energyCardItems .subTitleCardEnergy {
    font-size: 12px;
    text-transform: capitalize;
    color: #94a3b8;
}
.energyCardItems .subTitleCardEnergy__time{
    font-size: 12px;
    text-transform: lowercase;
    color: #94a3b8;
}

.cardEstaditics{
    border-radius: 15px;
    padding: 10px;
    background: linear-gradient(180deg, rgba(255, 255, 255, .03), rgba(0, 0, 0, .15));
}

.energyCardItems .estadisticsTitle{
    font-size: 12px;
}

.energyCardItems .estadisticsValues{
    font-size: 22px;
    font-weight: 700;
    margin-top: 4px;
}


</style>